type Months = {
    [key: number]: {
        name: string;
        dayCount: number;
    };
};


export class DatePicker{
    static monthsHelper: Months = {
        1: {
            name: "Январь",
            dayCount: 31,
        },
        2: {
            name: "Февраль",
            dayCount: 28,
        },
        3: {
            name: "Март",
            dayCount: 31,
        },
        4: {
            name: "Апрель",
            dayCount: 30,
        },
        5: {
            name: "Май",
            dayCount: 31,
        },
        6: {
            name: "Июнь",
            dayCount: 30,
        },
        7: {
            name: "Июль",
            dayCount: 31,
        },
        8: {
            name: "Август",
            dayCount: 31,
        },
        9: {
            name: "Сентябрь",
            dayCount: 30,
        },
        10: {
            name: "Октябрь",
            dayCount: 31,
        },
        11: {
            name: "Ноябрь",
            dayCount: 30,
        },
        12: {
            name: "Декабрь",
            dayCount: 31,
        },
    }

    static createDate = (day: number, month: number, year: number) => {
        return new Date(year, month - 1, day)
    }

    static getDaysCountInMonth = (currentMonth: number, currentYear: number) => {
        return (currentMonth === 2) && (currentYear % 4 === 0) ? 29 : this.monthsHelper[currentMonth].dayCount //Formatted Days count in current month
    }

    static dateEqual = (dateOne: Date, dateTwo: Date) => {
        if(dateOne.getDate() !== dateTwo.getDate()){
            return false
        }
        if(dateOne.getMonth() !== dateTwo.getMonth()){
            return false
        }

        return dateOne.getFullYear() === dateTwo.getFullYear();
    }

    static dateMidnight = (date: Date) => {
        const todayMidnight = date;
        todayMidnight.setHours(0, 0, 0, 0);
        return todayMidnight;
    }
}
